import { useTranslation } from "react-i18next";

import { getCloudRevenueSubject, isCloudRevenue } from "astrid-firestore/src/api/costs/utils/cloudRevenueCosts";
import money from "astrid-helpers/src/money";

import usePriceTypes from "../../../../prices/hooks/usePriceTypes";
import { priceAccessor } from "../../../../prices/utils/priceAccessors";

import CostDropdownMenu from "../../../components/CostDropdownMenu/CostDropdownMenu";

export default function useCostsTableColumns() {
	const { t } = useTranslation();

	const priceTypeNames = usePriceTypes();

	return [
		{
			id: "created",
			Header: t("created", "Created"),
			accessor: ({ created }) => created?.toDate().getTime() || "",
			Cell: ({ value }) => new Date(value).toLocaleString(),
			collapsing: true,
		},
		{
			id: "production.title",
			filter: "text",
			Header: t("production"),
			// Cloud revenues have no production; show the article or billing period instead.
			accessor: (cost) => cost.production?.title || (isCloudRevenue(cost) ? getCloudRevenueSubject(cost) : ""),
		},
		{
			id: "production.isbn",
			filter: "text",
			Header: t("isbn"),
		},
		{
			id: "production.language",
			filter: "select",
			Header: t("language", "Language"),
		},
		{
			id: "secondParty.name",
			filter: "text",
			Header: t("secondParty", "Second party"),
		},
		{
			id: "price.type",
			filter: "select",
			Header: t("type", "Type"),
			accessor: ({ price }) => priceTypeNames[price.type],
		},
		{
			id: "price.price",
			filter: "text",
			Header: t("price", "Price"),
			accessor: (cost) => {
				return cost?.price?.price === null ? t("hiddenPrice", "Hidden price") : priceAccessor(cost.price);
			},
			collapsing: false,
		},
		{
			id: "total",
			Header: t("sum", "Sum"),
			textAlign: "right",
			accessor: ({ total, expense }) => {
				return total * (expense ? -1 : 1);
			},
			collapsing: true,
			Cell: ({ value, row }) => money(value, row.original.price.currency),
		},
		{
			id: "menu",
			textAlign: "right",
			collapsing: true,
			disableSortBy: true,
			Cell: ({ row }) => <CostDropdownMenu cost={row.original} />,
		},
	];
}
